<template>
  <div class="news-filter-codes">
    <div class="tree-wrapper">
      <CodesTree
        ref="codesTree"
        :items="filteredCodes"
        :included="props.included"
        :excluded="props.excluded"
        :showExpanded="false /*currentTabIndex === 1*/"
        :searchPlaceholder="props.type === 'feeds' ? 'Поиск по лентам' : 'Поиск по кодам'"
        selectMode="partial"
        class="codes-tree"
        @change="changeItemState"
      />
    </div>
    <div
      v-if="selectedCodes?.length"
      class="selected-codes"
    >
      <div class="selected-title">
        Выбранные коды:
      </div>
      <div class="codes-list">
        <div
          v-for="code of selectedCodes"
          :key="code.item.id"
          class="selected-code"
          :class="code.state"
          :title="formatCodePath(code.item.path)"
        >
          <span>{{ code.item.name }}</span>
          <PsIcon
            name="close"
            size="14"
            class="remove-code"
            @click="uncheckItem(code.item.id)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, useTemplateRef } from 'vue'
import CodesTree from './codesTree/CodesTree.vue'
import PsIcon from '@/ContextTab/components/UI/PsIcon.vue'
import { EQuadboxState } from '@/ContextTab/components/UI/types'
import { useCodesStore } from '@/ContextTab/stores/codes'
import { formatCodePath } from '@/lib/codes'
import type {
  CodeSelectState,
  CodeFilterTypes,
} from '@/ContextTab/modules/news/codes/types'


const props = defineProps<{
  included: number[]
  excluded: number[]
  type: CodeFilterTypes
}>()

const emit = defineEmits<{
  (e: 'update', payload: CodeSelectState): void
}>()

// const tabs = [
//   {
//     id: 0,
//     label: 'Все',
//   },
//   {
//     id: 1,
//     label: 'Выбранные',
//   },
// ]

// const currentTabIndex = ref(0)

const codesTree = useTemplateRef<InstanceType<typeof CodesTree>>('codesTree')

const codesStore = useCodesStore()

const filteredCodes = computed(() =>
  props.type === 'feeds'
    ? codesStore.feedAndPubCodes
    : codesStore.nonFeedAndPubCodes,
)

const selectedCodes = computed(() =>
  [
    ...props.included.map((id) => ({
      item: codesStore.codesMap[Number(id)],
      state: EQuadboxState.included,
    })),
    ...props.excluded.map((id) => ({
      item: codesStore.codesMap[Number(id)],
      state: EQuadboxState.excluded,
    })),
  ],
)

function changeItemState(selectState: CodeSelectState) {
  emit('update', selectState)
}

function uncheckItem(id: number) {
  // more natural to emit event up, but data model isn't handy for it
  codesTree.value?.uncheckItem(id)
}
</script>

<style scoped>
.news-filter-codes {
  display: flex;
  flex-direction: column;
  height: 100%;

  .tree-wrapper {
    overflow: hidden;
    flex: 1;

    .codes-tree {
      height: 100%;
    }
  }

  .tabs {
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    display: flex;
    height: 2.625rem;
    padding: 10px;
    align-items: center;
    justify-content: flex-start;

    & span {
      font-size: 0.875rem;
      margin-right: 6px;
    }
  }

  .selected-codes {
    overflow: hidden;
    margin-bottom: var(--ps-padding-m);
    flex-direction: column;

    .selected-title {
      margin: var(--ps-padding-m) 0;
      font-size: var(--ps-font-size-m);
    }

    .codes-list {
      max-height: 110px;
      overflow-y: auto;
      font-size: var(--ps-font-size-s);

      .selected-code {
        display: inline-flex;
        align-items: center;
        border-radius: var(--ps-border-radius-m);
        padding: var(--ps-padding-xs) var(--ps-padding-s);
        margin: 0 var(--ps-padding-s) var(--ps-padding-s) 0;
        font-size: var(--ps-font-size-s);
        line-height: normal;

        &.included {
          border: 1px solid #9dbccd;
          background: #d9ebfb;
        }
        &.excluded {
          border: 1px solid #cd9d9d;
          background: #fbd9d9;
        }
      }

      .remove-code {
        cursor: pointer;
      }
    }
  }
}
</style>
